import React, { useState } from "react";
import "../styles/components/dashboard.css";
import UserDomains from "../components/UserDomains";
import ServerCreate from "../components/server-create";
import GTMTemplateLibrary from "../components/gtm-templates";
import BannerCreator from "../components/BannerCreator";
import LookerDashboard from "../components/lookerdashboard";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Servere",
      content: (
        <>
          <UserDomains />
        </>
      ),
    },
    { label: "Opprett ny server", content: <ServerCreate /> },
    { label: "Analyse", content: <LookerDashboard /> },
    { label: "GTM-Maler", content: <GTMTemplateLibrary /> },
    { label: "Cookiebanner", content: <BannerCreator /> },
  ];

  return (
    <div className="dashboard-container">
      {/* Dashboard Navigation */}
      <div className="dashboard-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${index === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Dashboard Content */}
      <div className="dashboard-content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default Dashboard;
